var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17168 1H7.82832C7.74344 1 7.65859 1.00353 7.574 1.01058C5.88847 1.15104 4.63594 2.6313 4.7764 4.31683L4.92009 6.04107C5.05358 7.6429 6.39262 8.875 8 8.875C9.60738 8.875 10.9464 7.6429 11.0799 6.04107L11.2236 4.31683C11.2306 4.23223 11.2342 4.14739 11.2342 4.0625C11.2342 2.37113 9.86305 1 8.17168 1Z",
    fill: "#237078"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4126 9.27974C10.5176 10.1154 9.31643 10.625 8 10.625C6.68357 10.625 5.48242 10.1154 4.58737 9.27974L3.04822 9.85692C1.8162 10.3189 1 11.4967 1 12.8125V14.125C1 14.6082 1.39175 15 1.875 15H14.125C14.6082 15 15 14.6082 15 14.125V12.8125C15 11.4967 14.1838 10.3189 12.9518 9.85692L11.4126 9.27974Z",
    fill: "#237078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerIcon);
export default __webpack_public_path__ + "static/media/ownerIcon.870ef5a42ad5fcea7fb332678991cd82.svg";
export { ForwardRef as ReactComponent };